import type { LottiePlayer } from 'lottie-web'
import lottie from 'lottie-web'
import type { CSSProperties } from 'react'
import { useEffect, useRef } from 'react'
import happyJoyAnimation from '/happy-joy.json?url'

interface JoyAnimatedImageProps {
  style?: CSSProperties
}

export function JoyAnimatedImage({ style }: JoyAnimatedImageProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const animationRef = useRef<LottiePlayer | null>(null)

  useEffect(() => {
    if (containerRef.current) {
      animationRef.current = lottie.loadAnimation({
        container: containerRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: happyJoyAnimation,
      })
    }

    return () => {
      if (animationRef.current) {
        animationRef.current.destroy()
      }
    }
  }, [])

  return <div ref={containerRef} style={style} />
}
